import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ModalContent, ModalBody } from 'app/components/Modal'

import './styles.scss'
const bc = 'login-information-modal'

class LoginInformationModal extends Component {
  componentDidMount() {
    this.props.clearAuthStatuses()
  }

  render() {
    const { onRequestClose, title, text, icon, button, withoutCross } = this.props
    return (
      <ModalBody onRequestClose={() => onRequestClose()} withoutCross={withoutCross}>
        <div className={`${bc}__icon`}>{icon}</div>
        <ModalContent className={`${bc}__description`}>
          <span className={`${bc}__title`}>{title}</span>
          <span className={`${bc}__text`}>{text}</span>
          {button}
        </ModalContent>
      </ModalBody>
    )
  }
}

LoginInformationModal.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  button: PropTypes.node,
}

export default LoginInformationModal
